<template>
  <div class="app-side-trigger" :class="{ open: isOpen }">
    <div class="trigger flex-center" @click="handleClick">
      <el-icon class="trigger__icon" color="white" :size="18">
        <ArrowRightBoldIcon v-if="isOpen" />
        <ArrowLeftBoldIcon v-else />
      </el-icon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCurrentAppInstance, RUNTIME_GLOBAL_EVENTS, computed, onMounted, reactive, ref, watch } from '@zto/zpage'
import * as ElementPlusIcons from '@element-plus/icons'

const { ArrowLeftBold: ArrowLeftBoldIcon, ArrowRightBold: ArrowRightBoldIcon } = ElementPlusIcons

const app = useCurrentAppInstance()

const emit = defineEmits(['trigger'])

const isOpen = ref<boolean>(false)


onMounted(() => {
  emit('trigger', isOpen.value)
})

function handleClick() {
  isOpen.value = !isOpen.value

  emit('trigger', isOpen.value)
}
</script>

<style lang="scss" scoped>
.app-side-trigger {
  position: fixed;
  z-index: 1999;
  bottom: 50px;
  right: 0;

  .trigger {
    cursor: pointer;
    background: var(--primary-1);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    width: 40px;
    height: 40px;

    &:hover {
      padding-right: 10px;
    }
  }

  &.open {
    .trigger {
      border-radius: 20px;

      &:hover {
        padding-right: 0px;
      }
    }

    right: 18px;
  }
}
</style>
